'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/admin-login.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _loading = require('@marmalade/loading');
var _loading2 = _interopRequireDefault(_loading);
var _message = require('@marmalade/message');
var _message2 = _interopRequireDefault(_message);
var _propTypes = require('@marmalade/prop-types');
var _jsCookie = require('js-cookie');
var _jsCookie2 = _interopRequireDefault(_jsCookie);
var _propTypes2 = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reactRouterDom = require('react-router-dom');
var _actions = require('../actions');
var _selectors = require('../selectors');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var AdminLogin = function (_Component) {
  _inherits(AdminLogin, _Component);
  function AdminLogin() {
    _classCallCheck(this, AdminLogin);
    return _possibleConstructorReturn(this, (AdminLogin.__proto__ || Object.getPrototypeOf(AdminLogin)).apply(this, arguments));
  }
  _createClass(AdminLogin, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
        loginWithRefreshToken = _props.loginWithRefreshToken,
        product = _props.product,
        setLoadError = _props.setLoadError,
        logout = _props.logout;
      logout();
      var token = _jsCookie2.default.get('RefreshToken');
      if (!token) {
        setLoadError('No cookie token found');
        return;
      }
      try {
        var _JSON$parse = JSON.parse(token),
          refreshToken = _JSON$parse.refreshToken,
          staffId = _JSON$parse.staffId;
        loginWithRefreshToken(product, refreshToken, staffId);
      } catch (err) {
        setLoadError('Error parsing cookie token');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
        loginError = _props2.loginError,
        loggedIn = _props2.loggedIn,
        redirect = _props2.redirect;
      if (loggedIn) {
        var cookieDomain = window.location.hostname.endsWith('.vm') ? '.wearemarmalade.vm' : process.env.REACT_APP_API_BASE_URI.replace(/https?:\/\/api/, '');
        _jsCookie2.default.remove('RefreshToken', {
          domain: cookieDomain
        });
        return _react2.default.createElement(_reactRouterDom.Redirect, {
          to: redirect,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 56
          },
          __self: this
        });
      }
      if (loginError) {
        return _react2.default.createElement(_message2.default, {
          type: 'error',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 59
          },
          __self: this
        }, loginError);
      }
      return _react2.default.createElement(_loading2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 61
        },
        __self: this
      });
    }
  }]);
  return AdminLogin;
}(_react.Component);
AdminLogin.propTypes = {
  // user
  product: _propTypes.product.isRequired,
  // withRouter
  history: _propTypes.history.isRequired,
  // dtp
  loginWithRefreshToken: _propTypes2.func.isRequired,
  logout: _propTypes2.func.isRequired,
  setLoadError: _propTypes2.func.isRequired,
  // stp
  loginError: _propTypes2.string.isRequired,
  loggedIn: _propTypes2.bool.isRequired,
  redirect: _propTypes2.string.isRequired
};
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    loginError: (0, _selectors.loginError)(state),
    loggedIn: (0, _selectors.isLoggedIn)(state)
  };
}, {
  loginWithRefreshToken: _actions.loginWithRefreshToken,
  setLoadError: _actions.setLoadError,
  logout: _actions.logout
})(AdminLogin));